import Server from '../server';
import Model from "../models/Model";
import EventBus from '../utils/EventBus';

export default class Query {

	static get(url, params) {

		return Query.prepare('GET', url, params);
	}

	static post(url, data, params, modelize = true) {

		if (modelize) {
			data = new Model(data).flat(false);
		}

		return Query.prepare('POST', url, params, data);
	}

	static put(url, data, params, modelize = true) {

		if (modelize) {
			data = new Model(data).flat(false);
		}

		return Query.prepare('PUT', url, params, data);
	}

	static patch(url, data, params, modelize = true) {

		if (modelize) {
			data = new Model(data).flat(false);
		}

		return Query.prepare('PATCH', url, params, data);
	}

	static delete(url, params) {

		return Query.prepare('DELETE', url, params);
	}

	static upload(files = [], onProgress = () => {}) {

		if (!(files instanceof Array)) {
			files = [files];
		}

		let form = new FormData();
		files.forEach(file => {
			form.append('file', file);
		});

		return Server.uploadFiles(form, onProgress);
	}

	static prepare(method, url, params, data) {

		return Server.api.request(method, url, params, data)
			.catch(error => {
				const code = parseInt(error.code);
				switch (code) {
					case 101:
					case 102:
					case 109:
					case 110:
						return EventBus.publish('LOCK_USER');
				}

				throw error;
			});
	}
}
